module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.user-levels')))]), _vm._v(" "), _c('base-list', {
    attrs: {
      "model": "user-levels",
      "columns": ['name'],
      "s-model": "user-level"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e452bf52!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-level/UserLevelList.vue
// module id = 1037
// module chunks = 2